module.exports = __webpack_public_path__ + "img/a-ziyuan15.fff16cd7.png";